import { c as m, d as y, e as v } from "./toNumber-CBEMFB9U.js";
import { n as x, l as S, D as _, f as l } from "./FormErrorMessage-C4ydi9Qu-Dx-JYo5Y.js";
import { css as i, cx as H } from "@emotion/css";
import { k as w } from "./index-CfLtmlq9-CmbUP_89.js";
import { memo as T } from "react";
const $ = (r) => {
  const e = w(r);
  return r === "light" ? i({
    color: x.jumbo,
    "&:active": {
      color: e.dark
    }
  }) : i({
    color: e.base,
    "&:active": {
      color: e.dark
    }
  });
};
function j(r, e) {
  for (var n = -1, t = r == null ? 0 : r.length, o = Array(t); ++n < t; )
    o[n] = e(r[n], n, r);
  return o;
}
var A = j, D = Array.isArray, M = D, u = m, U = A, k = M, z = y, E = 1 / 0, d = u ? u.prototype : void 0, f = d ? d.toString : void 0;
function b(r) {
  if (typeof r == "string")
    return r;
  if (k(r))
    return U(r, b) + "";
  if (z(r))
    return f ? f.call(r) : "";
  var e = r + "";
  return e == "0" && 1 / r == -E ? "-0" : e;
}
var I = b, N = I;
function P(r) {
  return r == null ? "" : N(r);
}
var K = P;
const p = {
  button: i({
    // Override default button styling
    border: "none",
    background: "none",
    outline: "none",
    padding: 0,
    fontFamily: S.body,
    fontSize: "inherit",
    fontWeight: "inherit",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    },
    "&:focus": {
      textDecoration: "underline"
    },
    "&:active": {
      textDecoration: "underline"
    }
  }),
  disabled: i({
    textDecoration: "none",
    pointerEvents: "none",
    cursor: "default",
    opacity: 0.3
  })
}, L = ({ className: r, theme: e = "primary", label: n, ...t }) => /* @__PURE__ */ _.jsx("button", { type: "button", ...t, className: H(p.button, $(e), t.disabled && p.disabled, r), children: n });
function q(r) {
  return function(e) {
    return r(e);
  };
}
var O = q, s = { exports: {} };
s.exports;
(function(r, e) {
  var n = v, t = e && !e.nodeType && e, o = t && !0 && r && !r.nodeType && r, h = o && o.exports === t, a = h && n.process, g = function() {
    try {
      var c = o && o.require && o.require("util").types;
      return c || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  r.exports = g;
})(s, s.exports);
var Q = s.exports;
function F(r) {
  return function(e) {
    return e == null ? void 0 : e[r];
  };
}
var V = F;
const X = (r) => {
  const { style: e, clientHeight: n, scrollHeight: t } = r;
  if (t > n) {
    e.height = `${t}px`;
    return;
  }
  e.height = "auto";
  const o = r.scrollHeight;
  e.height = `${t > o ? o : t}px`;
}, G = ({
  title: r,
  titleId: e,
  ...n
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": e,
    ...n,
    children: [
      r ? /* @__PURE__ */ l.jsx("title", { id: e, children: r }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M705.355 544.335H323.062c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h382.293c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667m-289.5 187.791H291.396c-125.397 0-227.392-102.016-227.392-227.413 0-125.376 101.995-227.371 227.392-227.371h123.627c23.552 0 42.667 19.093 42.667 42.667 0 23.552-19.115 42.667-42.667 42.667H291.396c-78.336 0-142.059 63.723-142.059 142.037 0 78.357 63.723 142.08 142.059 142.08h124.459c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667zm321.186 0H612.582c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h124.459c78.336 0 142.059-63.723 142.059-142.08 0-78.315-63.723-142.037-142.059-142.037H613.414c-23.552 0-42.667-19.115-42.667-42.667 0-23.573 19.115-42.667 42.667-42.667h123.627c125.397 0 227.392 101.995 227.392 227.371 0 125.397-101.995 227.413-227.392 227.413z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Z = T(G);
export {
  A as _,
  O as a,
  L as b,
  Q as c,
  V as d,
  I as e,
  M as i,
  Z as n,
  X as r,
  $ as s,
  K as t
};
